(function(){
  var $ = function(s,r){return (r||document).querySelector(s);};
  var money = function(c){return '$'+(c/100).toFixed(c%100?2:0);};
  var offer = $('#offer');
  if(!offer) return;

  var cfg = window.HIKKARI || {};
  var freeShip = cfg.freeShipCents || 7500;
  var mainVariants = cfg.mainVariants || {};
  var shirtVariants = cfg.shirtVariants || {};
  var root = cfg.routeRoot || '/';

  var state = { shirts:0, total:0, packName:'', size:null, ssize:null };

  function readPack(p){
    state.shirts = parseInt(p.getAttribute('data-shirts'),10) || 0;
    state.total = parseInt(p.getAttribute('data-total'),10) || 0;
    var nm = p.querySelector('.pack-name');
    state.packName = nm ? nm.textContent.trim() : '';
    var wrap = $('#shirt-size-wrap');
    if(wrap) wrap.style.display = state.shirts > 0 ? '' : 'none';
  }

  var selPack = $('.pack.sel') || $('.pack');
  if(selPack){ selPack.classList.add('sel'); readPack(selPack); }

  Array.prototype.forEach.call(document.querySelectorAll('.pack'), function(p){
    p.addEventListener('click', function(){
      Array.prototype.forEach.call(document.querySelectorAll('.pack'), function(x){x.classList.remove('sel');});
      p.classList.add('sel'); readPack(p); sync();
    });
  });

  Array.prototype.forEach.call(document.querySelectorAll('#sizes .size'), function(b){
    b.addEventListener('click', function(){
      Array.prototype.forEach.call(document.querySelectorAll('#sizes .size'), function(x){x.classList.remove('sel');});
      b.classList.add('sel'); state.size = b.getAttribute('data-size');
      if($('#size-echo')) $('#size-echo').textContent = state.size;
      if($('#sticky-size')) $('#sticky-size').textContent = 'Size '+state.size;
    });
  });
  Array.prototype.forEach.call(document.querySelectorAll('#shirt-sizes .size'), function(b){
    b.addEventListener('click', function(){
      Array.prototype.forEach.call(document.querySelectorAll('#shirt-sizes .size'), function(x){x.classList.remove('sel');});
      b.classList.add('sel'); state.ssize = b.getAttribute('data-ssize');
      if($('#shirt-size-echo')) $('#shirt-size-echo').textContent = state.ssize;
    });
  });

  function sync(){
    if($('#btn-total')) $('#btn-total').textContent = money(state.total);
    if($('#sticky-price')) $('#sticky-price').textContent = money(state.total);
    if($('#sticky-pack')) $('#sticky-pack').textContent = state.packName;
    var fill = $('#fill');
    if(fill){
      var pct = Math.min(100, Math.round(state.total/freeShip*100));
      fill.style.width = pct+'%';
      var rem = Math.max(0, freeShip-state.total);
      $('#mt').innerHTML = rem===0 ? '<span class="ok">\u2713 Your kit ships FREE.</span>'
        : 'Add <b>'+money(rem)+'</b> more to unlock <b>free shipping</b>.';
    }
  }
  sync();

  var tT;
  function toast(m){var t=$('#toast'); if(!t)return; t.innerHTML=m; t.classList.add('show'); clearTimeout(tT); tT=setTimeout(function(){t.classList.remove('show');},3000);}
  function shake(el){ if(el && el.animate) el.animate([{transform:'translateX(0)'},{transform:'translateX(-5px)'},{transform:'translateX(5px)'},{transform:'translateX(0)'}],{duration:280}); }

  function addBundle(){
    if(!state.size){ offer.scrollIntoView({behavior:'smooth',block:'center'}); shake($('#sizes')); toast('Pick a tracksuit size'); return; }
    var mainId = mainVariants[state.size];
    if(!mainId){ toast('Assign the tracksuit product in the theme editor to enable checkout'); return; }

    var items = [{ id: mainId, quantity: 1 }];
    if(state.shirts > 0){
      if(!state.ssize){ shake($('#shirt-sizes')); toast('Pick a shirt size'); return; }
      var shirtId = shirtVariants[state.ssize];
      if(!shirtId){ toast('Assign the shirt add-on product in the theme editor'); return; }
      items.push({ id: shirtId, quantity: state.shirts });
    }

    var cartUrl = cfg.cartUrl || (root + 'cart');
    var addUrl = cfg.cartAddUrl || (root + 'cart/add.js');
    var btn = $('#add'); var label = btn ? btn.innerHTML : '';
    if(btn){ btn.disabled = true; btn.textContent = 'Adding\u2026'; }

    function fail(msg){ if(btn){ btn.disabled = false; btn.innerHTML = label; } sync(); toast(msg || 'Couldn\u2019t add to cart. If you\u2019re in the theme editor, open the live store preview and try there.'); }

    fetch(addUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function(r){
      return r.json().then(function(data){ return { ok: r.ok, data: data }; });
    }).then(function(res){
      if(res.ok){
        window.location.href = cartUrl;   // valid Shopify route only
      } else {
        fail((res.data && (res.data.description || res.data.message)) || null);
      }
    }).catch(function(){ fail(); });
  }

  if($('#add')) $('#add').addEventListener('click', addBundle);
  if($('#sticky-add')) $('#sticky-add').addEventListener('click', function(){
    if(!state.size){ offer.scrollIntoView({behavior:'smooth',block:'center'}); shake($('#sizes')); toast('Pick a tracksuit size'); return; }
    addBundle();
  });
  if($('#sizeguide')) $('#sizeguide').addEventListener('click', function(){
    var panel = $('#sizeguide-panel');
    if(panel) panel.hidden = !panel.hidden;
  });

  var sticky = $('#sticky');
  var hero = $('.hero');
  if(sticky && hero){
    window.addEventListener('scroll', function(){
      var y = window.scrollY, hh = hero.offsetHeight;
      var oTop = offer.offsetTop, oBot = oTop+offer.offsetHeight;
      var inOffer = (y+window.innerHeight > oTop+120) && (y < oBot-100);
      if(y>hh && !inOffer) sticky.classList.add('show'); else sticky.classList.remove('show');
    }, {passive:true});
  }
})();
